module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBoldItalic.497c28b.ttf";